import React, {useState} from 'react'
import LabeledValue from '../common/LabeledValue'
import {formatDateString, getLegacyBillingInfo} from '../../services/utils'
import {Reservation} from '../../types/app-types'
import {downloadLease} from '../../services/bluemoon'
import LoaderInline from '../common/LoaderInline'
import {getLogger} from '../../services/logging'

interface AccountLeaseCardProps {
  leaseSignatureId: string
  reservation: Reservation
  className?: string
}

const logger = getLogger('AccountLeaseCard')

const AccountLeaseCard = ({
  reservation,
  leaseSignatureId,
  className = ''
}: AccountLeaseCardProps) => {
  const [isDownloading, setIsDownloading] = useState(false)
  const legacyPortalUrl = getLegacyBillingInfo(reservation.property?.code)
    ?.portalUrl

  return (
    <div className={className}>
      <div className="card-default h-full">
        <div className="card-body-default">
          <div className="flex-grow">
            <h1 className="card-header">Lease Detail</h1>
            {reservation.property ? (
              <LabeledValue
                value={reservation.property?.name}
                label="Property"
              />
            ) : (
              ''
            )}
            {reservation.unit ? (
              <LabeledValue
                value={`Unit ${reservation.unit?.name}`}
                label="Apartment/Unit"
              />
            ) : (
              ''
            )}
            {reservation.unitGroup ? (
              <LabeledValue
                value={reservation.unitGroup?.name}
                label="Unit Type"
              />
            ) : (
              ''
            )}
            <LabeledValue
              value={`${formatDateString(
                reservation.arrival
              )} - ${formatDateString(reservation.departure)}`}
              label="Lease Term"
            />
          </div>
          <div className="card-actions flex-none h-8">
            {!leaseSignatureId ? (
              <div className="text-sm">
                Login
                <a
                  href={legacyPortalUrl}
                  target="_blank"
                  className="link link-primary mx-1"
                >
                  here
                </a>
                for your lease.
              </div>
            ) : (
              ''
            )}
            {leaseSignatureId && !isDownloading ? (
              <a
                className="link link-primary text-sm"
                onClick={() => {
                  if (!isDownloading) {
                    setIsDownloading(true)
                    downloadLease(reservation.property.id, leaseSignatureId)
                      .catch(e => {
                        logger.logError('Failed to download lease document: ', {
                          error: e
                        })
                      })
                      .finally(() => setIsDownloading(false))
                  }
                }}
              >
                Download Lease
              </a>
            ) : (
              ''
            )}
            {leaseSignatureId && isDownloading ? (
              <LoaderInline text="Downloading Lease..." />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountLeaseCard
